import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import blue from '../../assets/images/news/mark_grp.svg';
import red from '../../assets/images/news/mark_grp_rd.svg';

import './news_styles/newsupper.css';
import Chartt from '../graph/chartt';

export default function NewsUpper() {
  return (
    <>
      <Container className='mt-5 mb-5 news_upper'>
        <Row className='news_up'>
              <Col lg={3} md={6} className='mt-5'>
              <div className="news_first_data news_data d-flex align-items-center gap-2">
              <div className="news_fst">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="news_fst_grap">
                <Chartt />
              </div>
            </div>
              </Col>
            
              <Col lg={3} md={6} className='mt-5'>
              <div className="news_second_data news_data d-flex align-items-center gap-2">
              <div className="news_scnd">
                <p>ET/USDT</p>
                <h6 className='news_up_h6 m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="news_scnd_grap">
                <Chartt />
              </div>
            </div>
              </Col>
           
            <Col lg={3} md={6} className='mt-5'>
            <div className="news_third_data news_data d-flex align-items-center gap-2">
              <div className="news_trd">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="news_trd_grap">
                <Chartt />
              </div>
            </div>
            </Col>

            <Col lg={3} md={6} className='mt-5'>
            <div className="news_forth_data news_data d-flex align-items-center gap-2">
              <div className="news_fth">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="news_fth_grap">
                <Chartt />
              </div>
            </div>            
            </Col>
        </Row>
      </Container>
    </>
  )
}